import { formatCurrency, getLabelFromStorage } from '@pb/utils'

import { AddToBagVerificationProductData, MiniCartData } from 'features/favourites/duck/types'

export const getProductInformation = (data: MiniCartData): AddToBagVerificationProductData => {
  const productTileData = {
    data: {
      variantCode: data.itemVariantCode,
      name: data.itemName,
      price: data.itemOrdinaryPriceValue ? formatCurrency(data.itemOrdinaryPriceValue) : undefined,
      reducedPrice: data.itemRedPriceValue ? formatCurrency(data.itemRedPriceValue) : undefined,
      priorPrice: { formattedValue: data.itemPriorPrice },
      image: data.imgUrl,
      imageAltText: data.imgAlt,
      link: data.productUrl,
    },
    tableData: [
      {
        name: data.quantityLabel,
        value: '1',
      },
      {
        name: data.colorLabel,
        value: data.itemColor,
      },
      {
        name: data.sizeLabel,
        value: data.itemSize,
      },
    ],
    priorPriceLabel: getLabelFromStorage('prior.price.label', { replacements: ' ' }),
  }

  return {
    productTileData,
  } as AddToBagVerificationProductData
}
